import { render, staticRenderFns } from "./item-playbook.vue?vue&type=template&id=6f3771bf&"
import script from "./item-playbook.vue?vue&type=script&lang=js&"
export * from "./item-playbook.vue?vue&type=script&lang=js&"
import style0 from "./item-playbook.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f3771bf')) {
      api.createRecord('6f3771bf', component.options)
    } else {
      api.reload('6f3771bf', component.options)
    }
    module.hot.accept("./item-playbook.vue?vue&type=template&id=6f3771bf&", function () {
      api.rerender('6f3771bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/item-playbook/item-playbook.vue"
export default component.exports